import { useState } from "react";
import { Route, X, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { catLabel } from "@/lib/lore";

export const PathsPicker = ({ candidates, selected, colorOf, onToggle, onClear, timelineName }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size="sm" variant={selected.length ? "default" : "ghost"} data-testid="paths-button">
          <Route className="mr-1.5 h-4 w-4" />Paths{selected.length ? ` (${selected.length})` : ""}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" collisionPadding={12} className="w-[calc(100vw-1.5rem)] max-w-xs border-[#2D3442] bg-[#0F131A] p-3" data-testid="paths-popup">
        <div className="mb-1 flex items-center justify-between">
          <div className="lf-label">Travel paths</div>
          <button onClick={() => setOpen(false)} className="flex h-8 w-8 items-center justify-center rounded-md text-[#A8A090] hover:bg-[#1A202C]" aria-label="Close" data-testid="paths-close"><X className="h-4 w-4" /></button>
        </div>
        <p className="mb-3 text-[11px] text-[#A8A090]">Routes follow events at pinned places on <span className="text-[#C4B5FD]">{timelineName}</span>.</p>
        {candidates.length === 0 ? (
          <p className="text-xs text-[#A8A090]" data-testid="paths-empty">No characters or factions have events at places pinned on this map yet. Give events a location that has a pin here.</p>
        ) : (
          <div className="max-h-[50dvh] space-y-1 overflow-y-auto lf-scroll">
            {candidates.map(({ entity, stops }) => {
              const on = selected.includes(entity.id);
              return (
                <button key={entity.id} onClick={() => onToggle(entity.id)} data-testid={`paths-option-${entity.id}`}
                  className={`flex w-full items-center gap-2 rounded-sm border px-2.5 py-2 text-left text-sm transition-colors ${on ? "border-[#D97706]/60 bg-[#D97706]/10" : "border-transparent hover:bg-[#1A202C]"}`}>
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border" style={on ? { background: colorOf(entity.id), borderColor: colorOf(entity.id) } : { borderColor: "#2D3442" }}>
                    {on && <Check className="h-3 w-3 text-[#0B0D10]" />}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-[#E8DFD1]">{entity.name}</span>
                  <span className="shrink-0 text-[10px] text-[#A8A090]">{catLabel(entity.category)} · {stops.length} stop{stops.length === 1 ? "" : "s"}</span>
                </button>
              );
            })}
          </div>
        )}
        {selected.length > 0 && <button onClick={onClear} className="mt-3 text-xs text-[#F59E0B] hover:underline" data-testid="paths-clear">Hide all paths</button>}
      </PopoverContent>
    </Popover>
  );
};
